/* unplugin-vue-components disabled */import { render } from "./AIQuizGenerationTextField.vue?vue&type=template&id=21a56c76&ts=true"
import script from "./AIQuizGenerationTextField.vue?vue&type=script&lang=ts"
export * from "./AIQuizGenerationTextField.vue?vue&type=script&lang=ts"

import "./AIQuizGenerationTextField.vue?vue&type=style&index=0&id=21a56c76&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__